export const RESPONSE_STATUSES = {
  SESSION_EXIST: 460,
  PASSWORD_INCORRECT: 466,
  VERIFICATION_CODE_INCORRECT: 467,
  CHALLENGE_PARTICIPANT_ALREADY_EXIST: 468,
  NUTRITION_ACCOUNT_NOT_FOUND_FOR_CHALLENGE: 469,
  CORPORATE_LOGIN: 210,
  UNAUTHORIZED: 401,
  PAYMENT_REQUIRED: 402,
  INVALID: 409,
} as const;
